import React from "react";
import { Form, FormGroup } from 'reactstrap';
import PropTypes from "prop-types";

import {FormField} from "../../../../../utils/FormFields";

function PhysicalPersonLegalAddress({person, changedPerson, showChanges, remove}) {
  const showLegalAddress = changedPerson || person;
  const editLegalAddress = changedPerson.LegalAddress[0];
  let compareLegalAddress;
  person.LegalAddress.forEach((d) => {
    if (parseInt(d.LegalAddressId, 10)
      === parseInt(editLegalAddress.LegalAddressId, 10)) {
        compareLegalAddress = d;
    }
  });
  let color = 'black';
  if (showLegalAddress) {
    if (compareLegalAddress === undefined) {
      color = 'green';
    } else {
      color = remove ? 'red' : '#36a9e1';
    }
  }
  return (
    <Form>
      {showChanges
        ? (
          <FormGroup tag="fieldset">
            {
               (
                <FormToShow
                  legalAddress={editLegalAddress}
                  refLegalAddress={compareLegalAddress}
                />
              )}
          </FormGroup>
        )
        : (
          <FormGroup tag="fieldset">
            {compareLegalAddress
              && (
                <FormToShow
                  legalAddress={compareLegalAddress}
                />
              )}
          </FormGroup>
        )}
    </Form>
  );
}

PhysicalPersonLegalAddress.propTypes = {
  person: PropTypes.object.isRequired,
  changedPerson: PropTypes.object.isRequired,
  showChanges: PropTypes.bool.isRequired,
};

export default PhysicalPersonLegalAddress;

const FormToShow = ({legalAddress, refLegalAddress}) => (
  <React.Fragment>
  {legalAddress && (
    <React.Fragment>
      {legalAddress && legalAddress.LegalAddressCityName !== undefined && (
        <FormField
          label="Legal Address City: "
          value={legalAddress.LegalAddressCityName}
          name="LegalAddresCityName"
          changedColor={refLegalAddress && refLegalAddress.LegalAddressCityName !== refLegalAddress.LegalAddressCityName}
        />
      )}
      {legalAddress && legalAddress.LegalAddressStateName !== undefined && (
        <FormField
          label="Legal Address State: "
          value={legalAddress.LegalAddressStateName}
          name="LegalAddressStateName"
          changedColor={refLegalAddress && refLegalAddress.LegalAddressStateName !== refLegalAddress.LegalAddressStateName}
        />
      )}
      {legalAddress && legalAddress.LegalAddressCountryName !== undefined && (
        <FormField
          label="Legal Address Country: "
          name="LegalAddressCountryName"
          value={legalAddress.LegalAddressCountryName}
          changedColor={refLegalAddress && refLegalAddress.LegalAddressCountryName !== refLegalAddress.LegalAddressCountryName}
        />
      )}
      {legalAddress && legalAddress.LegalAddressStreet !== undefined && (
        <FormField
          label="Legal Address Street: "
          value={legalAddress.LegalAddressStreet}
          name="LegalAddressStreet"
          changedColor={refLegalAddress && refLegalAddress.LegalAddressStateName !== refLegalAddress.LegalAddressStateName}
        />
      )}
      {legalAddress && legalAddress.LegalAddressNumber !== undefined && (
        <FormField
          label="Legal Address Number: "
          value={String(legalAddress.LegalAddressNumber)}
          name="LegalAddressNumber"
          type="number"
          changedColor={refLegalAddress && refLegalAddress.LegalAddressNumber !== refLegalAddress.LegalAddressNumber}
          dataTypeDecimalName="currency"
        />
      )}
      {legalAddress && legalAddress.LegalAddressType !== undefined && (
        <FormField
          label="Legal Address Type: "
          value={legalAddress.LegalAddressType}
          name="LegalAddressType"
          type="number"
          changedColor={refLegalAddress && refLegalAddress.LegalAddressType !== refLegalAddress.LegalAddressType}
          dataTypeDecimalName="currency"
        />
      )}
      {legalAddress && legalAddress.LegalAddressZipCode !== undefined && (
        <FormField
          label="Legal Address Zip Code: "
          value={String(legalAddress.LegalAddressZipCode)}
          name="LegalAddressZipCode"
          type="number"
          changedColor={refLegalAddress && refLegalAddress.LegalAddressZipCode !== refLegalAddress.LegalAddressZipCode}
          dataTypeDecimalName="currency"
          decimalScale={0}
        />
      )}
      {legalAddress && legalAddress.LegalAddressExtraInformation1 !== undefined && (
        <FormField
          label="Legal Address Neighbourhood: "
          value={legalAddress.LegalAddressExtraInformation1}
          name="LegalAddressExtraInformation1"
          type="textarea"
          changedColor={refLegalAddress && refLegalAddress.LegalAddressExtraInformation1 !== refLegalAddress.LegalAddressExtraInformation1}
        />
      )}
      {legalAddress && legalAddress.LegalAddressExtraInformation2 !== undefined && (
        <FormField
          label="Legal Address References: "
          value={legalAddress.LegalAddressExtraInformation2}
          name="LegalAddressExtraInformation2"
          type="textarea"
          changedColor={refLegalAddress && refLegalAddress.LegalAddressExtraInformation2 !== refLegalAddress.LegalAddressExtraInformation2}
        />
      )}
    </React.Fragment>
  )}
</React.Fragment>
);

FormToShow.propTypes = {
  legalAddress: PropTypes.object.isRequired,
  refLegalAddress: PropTypes.object,
};

FormToShow.defaultProps = {
  refLegalAddress: undefined,
};
